import { useParams } from "react-router-dom";
import { useState } from "react";

export default function InterviewSchedule() {
  const { id } = useParams();

  const [date, setDate] = useState("");

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Interview Schedule</h1>

      <div className="bg-white p-6 rounded-xl shadow w-96 border">
        <label className="block font-medium mb-2">Select Interview Date</label>
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="border p-2 rounded w-full"
        />

        <button className="mt-4 bg-blue-600 text-white px-4 py-2 rounded">
          Save Schedule
        </button>
      </div>
    </div>
  );
}
